import React, { memo, useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Stack,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, InputAdornment } from "@mui/material";
import cross from "../Images/cross.png";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import { useLoaderData } from "react-router-dom";
import { Loader } from "../Components/Components";
import {
  billImport,
  discountConfig,
  getBankAccounts,
  getLatestVendorID,
  getPCnumber,
  getPCsByCorporation,
  getVenderlist,
  loadCorporationDefaultPaymentAccount,
  LoadLastUsedAccount,
  loadPaymentMethods,
  updateDiscountAccountAPI,
} from "../API/nimble";
import { enqueueSnackbar } from "notistack";






export const AccountTypesEnum = {
  Bank: "0FA700000000000000000000000000000003",
  CreditCard: "0FA700000000000000000000000000000025",
  AccountsReceivable: "0FA700000000000000000000000000000004",
  AccountsPayable: "0FA700000000000000000000000000000012",
};

const textFieldCommonSx = {
  bgcolor: "#f2f2f2",
  "& .MuiInputBase-input::placeholder": { fontSize: "11px" },
  "& .MuiInputBase-root": {
    fontSize: 12,
  },
  "& .MuiInputBase-input": {
    fontSize: 12,
  },
};

const CommonAutocomplete = ({
  label,
  required = false,
  value,
  onChange,
  options = [],
  getOptionLabel = (option) => option?.Name || "",
  isOptionEqualToValue = (option, value) => option?.ID === value?.ID,
  placeholder,
  sx,
  size = "small",
  disableClearable = true,
  width = 200,
  ...rest
}) => {
  return (
    <Stack direction="row" spacing={2} alignItems="center" pb={2}>
      <Typography sx={{ width, fontSize: 13 }}>
        {label}{" "}
        {required && (
          <Typography component="span" color="error" sx={{ fontSize: 13 }}>
            *
          </Typography>
        )}
      </Typography>

      <Autocomplete
        disableClearable={disableClearable}
        size={size}
        sx={{ flexGrow: 1, width: "100%", ...sx }}
        value={value}
        onChange={(event, newValue) => onChange(newValue)}
        options={options}
        getOptionLabel={getOptionLabel}
        isOptionEqualToValue={isOptionEqualToValue}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder || `Select ${label}`}
          />
        )}
        {...rest}
      />
    </Stack>
  );
};

const ImportFilesDialog = ({
  open,
  onClose,
  corporation,
  setCorporation,
  getUploadedGridData,
}) => {
  const { token, corporations, preferences, setSelect ,privileges,getBillPrivileges,billPrivileges} = useLoaderData();
 

  const [loading, setLoading] = useState(false);
  const selectOption = setSelect;
  // const [corporation, setCorporation] = useState(selectOption);
  const [pcs, setPcs] = useState([]);
  const [profitCentre, setProfitCentre] = useState(null);
  const [bankAccountList, setBankAccountList] = useState([]);
  const [discountAccountList, setDiscountAccountList] = useState([]);
  const [bankAcc, setBankAcc] = useState([]);
  const [discountAccount, setDiscountAccount] = useState("");
  const [venderAccountList, setvenderAccountList] = useState([]);
  const [vender, setVender] = useState(null);
  const [pcNumber, setPcNumber] = useState("");
  const [dcpSummaryFile, setDcpSummaryFile] = useState(null);
  const [dcpDivisionFile, setDcpDivisionFile] = useState(null);
  const [dcpSummaryFileName, setDcpSummaryFileName] = useState("");
  const [dcpDivisionFileName, setDcpDivisionFileName] = useState("");

  const [openConfirm, setOpenConfirm] = useState(false);
  const [discountDetailsForDialog, setDiscountDetailsForDialog] = useState("");

  useEffect(() => {
    getFieldsInfo();
  }, [corporation]);

  useEffect(() => {
    const fetchPcNumber = async () => {
      try {
        const pcId = profitCentre?.ID === "select" ? false : profitCentre?.ID;
        if (!pcId) {
          setPcNumber("");
          return;
        }
        const data = await getPCnumber(pcId, token);

        const candidates = [
          data?.PCNumber,
          data?.pcNumber,
          data?.PCData?.PCNumber,
          data?.PCData?.pcNumber,
          data?.ProfitCenter?.PCNumber,
          data?.ProfitCenter?.pcNumber,
          data?.Data?.PCNumber,
          data?.Data?.pcNumber,
          data?.Number,
          data?.PCCode,
        ];
        const resolved =
          candidates.find(
            (v) => typeof v === "string" && v.trim().length > 0
          ) || "";
        setPcNumber(resolved);
      } catch (e) {
        console.error("Error fetching PC details", e);
      }
    };

    fetchPcNumber();
  }, [profitCentre, token]);

  // When dialog is open and corporation changes, refresh PCs and toggle PC fields
  useEffect(() => {
    const refreshPCsForDialog = async () => {
      try {
        const corpId = corporation?.ID;
        if (!corpId) {
          setPcs([]);
          setProfitCentre(null);
          setPcNumber("");
          return;
        }
        const data = await getPCsByCorporation(corpId, token);
        const list = Array.isArray(data) ? data : [];
        setPcs(list);
        if (list.length === 1) {
          setProfitCentre(list[0]);
        } else {
          setProfitCentre(null);
        }
        if (list.length === 0) {
          setPcNumber("");
        }
      } catch (e) {
        console.error("Failed to refresh PCs for selected corporation", e);
        setPcs([]);
        setProfitCentre(null);
        setPcNumber("");
      }
    };
    if (
      !corporation ||
      corporation?.ID === "select" ||
      corporation?.ID === selectOption.ID
    ) {
      refreshPCsForDialog();
    }
  }, [corporation]);

  const getFieldsInfo = async () => {
    if (
      !corporation ||
      corporation?.ID === "select" ||
      corporation?.ID === selectOption.ID
    ) {
      enqueueSnackbar("Please select Corporation", { variant: "warning" });
      return;
    }

    try {
      setLoading(true);
      const corpId = corporation?.ID;
      if (!corpId) {
        setLoading(false);
        return;
      }
      const data = await getPCsByCorporation(corpId, token);

      if (data.length === 2) {
        setPcs(data);
        setProfitCentre(data[1]);
      } else {
        setPcs(data);
        setProfitCentre(data[0]);
      }
      const allAccounts = await getBankAccounts(
        corporation.ID,
        "000000000000000000000000000000000000",
        token
      );

      const selectOptions = { ID: "select", Name: "-Select-" };

      const banks = Array.isArray(allAccounts)
        ? [
            selectOptions,
            ...allAccounts.filter((a) => {
              const accountTypeID = a?.AccountTypeID || a?.AccountTypeId || "";
              return (
                accountTypeID === AccountTypesEnum.Bank ||
                accountTypeID === AccountTypesEnum.CreditCard
              );
            }),
          ]
        : [selectOptions];

      const discounts = Array.isArray(allAccounts)
        ? [
            selectOptions,
            ...allAccounts.filter((a) => {
              const accountTypeID = a?.AccountTypeID || a?.AccountTypeId || "";
              return (
                accountTypeID !== AccountTypesEnum.AccountsReceivable &&
                accountTypeID !== AccountTypesEnum.AccountsPayable
              );
            }),
          ]
        : [selectOptions];

      setBankAccountList(banks);
      setDiscountAccountList(discounts);
      const loadCrpPayAcc = await loadCorporationDefaultPaymentAccount(
        corpId,
        token
      );

      if (loadCrpPayAcc.accountID) {
        const match = banks.find((acc) => acc.ID === loadCrpPayAcc.accountID);
        setBankAcc(match);
      } else {
        const loadPayMethods = await loadPaymentMethods(token);

        if (Array.isArray(loadPayMethods)) {
          const manualACH = loadPayMethods.find((m) => m.name === "Manual ACH");
          let selectedBank = banks[0];

          if (manualACH) {
            const payload = {
              corporationID: corpId,
              payMethodID: manualACH.id,
            };

            const latestUsedAcc = await LoadLastUsedAccount(payload, token);
            if (latestUsedAcc?.accountID) {
              const match = banks.find(
                (acc) => acc.ID === latestUsedAcc.accountID
              );

              selectedBank = match;
            }
          }

          setBankAcc(selectedBank);
        }
      }

      const discountsAccDefault = await discountConfig(corpId, token);
      if (discountsAccDefault.statusCode === 200) {
        const match = discounts.find(
          (d) => d.ID === discountsAccDefault.accountID
        );
        setDiscountAccount(match);
      } else {
        setDiscountAccount(discounts[0]);
      }
      const venderList = await getVenderlist(corpId, token);

      const safeVendorList = Array.isArray(venderList) ? venderList : [];
      setvenderAccountList(safeVendorList);

      const prevVendor = await getLatestVendorID(corpId, token);

      if (prevVendor.statusCode !== 404) {
        const match = safeVendorList.find((v) => v.id === prevVendor.id);
        setVender(match);
      } else {
        setVender(
          safeVendorList.length === 2 ? safeVendorList[1] : safeVendorList[0]
        );
      }

      setDcpDivisionFile(null);
      setDcpSummaryFile(null);
      setDcpDivisionFileName("");
      setDcpSummaryFileName("");
    } catch (error) {
      setDcpDivisionFile(null);
      setDcpSummaryFile(null);
      setDcpDivisionFileName("");
      setDcpSummaryFileName("");
      enqueueSnackbar("Error while getting field info", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (event, setFileState, setFileNameState) => {
    const file = event.target.files && event.target.files[0];

    if (file) {
      const allowedExtensions = ["csv", "xls", "xlsx"];
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (allowedExtensions.includes(fileExtension)) {
        setFileState(file);
        setFileNameState(file.name);
      } else {
        enqueueSnackbar(
          `Invalid file type. Allowed types: ${allowedExtensions.join(", ")}`,
          { variant: "warning" }
        );
        event.target.value = "";
        setFileState(null);
        setFileNameState("");
      }
    } else {
      setFileState(null);
      setFileNameState("");
    }
  };

  const handleDiscountChange = (newValue) => {
    setDiscountAccount(newValue);
    if (newValue && newValue.ID !== "select") {
      setDiscountDetailsForDialog(newValue);
      setOpenConfirm(true);
    }
  };

  const handleImport = async () => {
 
if (!privileges.Create) {
  enqueueSnackbar("You don't have permission to import", { variant: "error" });
  return;
}

 
const billEntryPrivilege = getBillPrivileges.find(
  (p) => p.MenuID === billPrivileges.BillEntry
);

if (!billEntryPrivilege?.Create) {
  enqueueSnackbar("You don't have permission to import Bill Entry", { variant: "error" });
  return;
}

 
const billPaymentPrivilege = getBillPrivileges.find(
  (p) => p.MenuID === billPrivileges.BillPayment
);

if (!billPaymentPrivilege?.Create) {
  enqueueSnackbar("You don't have permission to import Bill Payment", { variant: "error" });
  return;
}








    const validations = [
      {
        valid: corporation && corporation.ID !== "select",
        msg: "Please select Corporation",
      },
      {
        valid:
          pcs?.length > 1 ? profitCentre && profitCentre.ID !== "select" : true,
        msg: "Please select Profit Center",
      },
      { valid: pcs?.length > 1 ? !!pcNumber : true, msg: "PC Number missing" },
      { valid: vender && vender.id !== "select", msg: "Please select Vendor" },
      {
        valid: bankAcc && bankAcc.ID !== "select",
        msg: "Please select Bank Account",
      },
      // {
      //   valid: discountAccount && discountAccount.ID !== "select",
      //   msg: "Please select Discount Account",
      // },
      { valid: !!dcpSummaryFile, msg: "Please browse DCP Summary file" },
      {
        valid: !!dcpDivisionFile,
        msg: "Please browse DCP Division Summary file",
      },
    ];
    const failed = validations.find((v) => !v.valid);
    if (failed) {
      enqueueSnackbar(failed.msg, { variant: "warning" });
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();
      if (dcpSummaryFile) formData.append("DCPSummary", dcpSummaryFile);
      if (dcpDivisionFile)
        formData.append("DCPDivisionSummary", dcpDivisionFile);

      const payload = {
        CorpId: corporation.ID,
        PcId: profitCentre?.ID === "select" ? "" : profitCentre?.ID,
        VendorId: vender.id,
        BankAccountId: bankAcc.ID,
        DiscountAccountId:
          discountAccount?.ID === "select" ? "" : discountAccount?.ID,
      };

      const result = await billImport(formData, token, payload);
      if (result.statusCode === 400) {
        enqueueSnackbar(`${result.status}`, { variant: "warning" });
        setDcpDivisionFile(null);
        setDcpSummaryFile(null);
        setDcpDivisionFileName("");
        setDcpSummaryFileName("");
        return;
      }

      if (result.statusCode === 200) {
        enqueueSnackbar(`${result.status}`, { variant: "success" });
        onClose();
        getUploadedGridData();
      }
    } catch (error) {
      enqueueSnackbar("Error while importing", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Dialog
        open={open}
        PaperProps={{ sx: { width: "50%", overflow: "auto" } }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            bgcolor: "#cfddbb",
            textAlign: "right",
            p: 1,
            fontSize: 14,
          }}
        >
          DCP Import
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Button
              sx={{
                bgcolor: "#bfe9fb",
                textTransform: "none",
                color: "black",
                fontSize: 12,
                px: 4,
              }}
              onClick={handleImport}
            >
              Import
            </Button>
            {/* <IconButton onClick={onClose}> */}
            <IconButton onClick={onClose}>
              <img src={cross} alt="delete" style={{ width: 32, height: 32 }} />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 6, gap: 6 }}>
          <Stack gap={1}>
            <CommonAutocomplete
              label="Corporation"
              required
              value={corporation}
              onChange={setCorporation}
              options={corporations}
              getOptionLabel={(option) =>
                preferences.isLegalName ? option.LegalName : option.Name
              }
            />

            {Array.isArray(pcs) && pcs.length > 1 && (
              <>
                <CommonAutocomplete
                  label="Profit Centre"
                  required
                  value={profitCentre}
                  onChange={setProfitCentre}
                  options={pcs}
                  getOptionLabel={(option) => option?.Name || ""}
                  isOptionEqualToValue={(option, value) =>
                    option?.ID === value?.ID
                  }
                />

                <Stack direction="row" spacing={2} alignItems="center" pb={2}>
                  <Typography sx={{ width: 200, fontSize: 13 }}>
                    PC Number{" "}
                    <Typography
                      component="span"
                      color="error"
                      sx={{ fontSize: 13 }}
                    >
                      *
                    </Typography>
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    value={pcNumber}
                    InputProps={{ readOnly: true }}
                  />
                </Stack>
              </>
            )}

            <CommonAutocomplete
              label="Vendor"
              required
              value={vender}
              onChange={setVender}
              options={venderAccountList}
              getOptionLabel={(option) =>
                option?.name || option?.Name || option?.VendorName || ""
              }
              isOptionEqualToValue={(option, value) =>
                (option?.id && value?.id && option.id === value.id) ||
                (option?.ID && value?.ID && option.ID === value.ID) ||
                (option?.VendorID &&
                  value?.VendorID &&
                  option.VendorID === value.VendorID)
              }
            />

            <CommonAutocomplete
              label="Bank Account"
              required
              blurOnSelect
              value={bankAcc}
              onChange={setBankAcc}
              options={bankAccountList}
              renderOption={(props, option) => (
                <li {...props}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    width="100%"
                    spacing={2}
                  >
                    <span style={{ fontWeight: 500, whiteSpace: "nowrap" }}>
                      {option.Name}
                    </span>
                    <span style={{ fontSize: 12, opacity: 0.7 }}>
                      {option.AccountTypeName}
                    </span>
                  </Stack>
                </li>
              )}
              slotProps={{
                paper: { sx: { width: 450 } },
                listbox: { sx: { width: 450 } },
              }}
            />

            <CommonAutocomplete
              label="Discount Account"
              // required
              value={discountAccount}
              blurOnSelect
              onChange={handleDiscountChange}
              options={discountAccountList}
              renderOption={(props, option) => (
                <li {...props}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    width="100%"
                    spacing={2}
                  >
                    <span style={{ fontWeight: 500, whiteSpace: "nowrap" }}>
                      {option.Name}
                    </span>
                    <span style={{ fontSize: 12, opacity: 0.7 }}>
                      {option.AccountTypeName}
                    </span>
                  </Stack>
                </li>
              )}
              slotProps={{
                paper: { sx: { width: 450 } },
                listbox: { sx: { width: 450 } },
              }}
            />
          </Stack>

          <Stack direction="row" spacing={2} alignItems="center" pb={2}>
            <Typography sx={{ width: 141, fontSize: 13 }}>
              DCP Summary{" "}
              <Typography component="span" color="error" sx={{ fontSize: 13 }}>
                *
              </Typography>
            </Typography>
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1 }}
            >
              <TextField
                fullWidth
                size="small"
                value={dcpSummaryFileName}
                placeholder="Choose file with extension (.csv, .xls, .xlsx)"
                InputProps={{
                  readOnly: true,
                  endAdornment: dcpSummaryFileName && (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => {
                          setDcpSummaryFile(null);
                          setDcpSummaryFileName("");
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={textFieldCommonSx}
              />
              <Button
                component="label"
                sx={{ bgcolor: "#92dede", color: "black", fontSize: 12 }}
              >
                Browse
                <input
                  key={dcpSummaryFileName}
                  hidden
                  accept=".csv,.xls,.xlsx"
                  type="file"
                  onChange={(e) =>
                    handleFileChange(
                      e,
                      setDcpSummaryFile,
                      setDcpSummaryFileName
                    )
                  }
                />
              </Button>
            </Box>
          </Stack>

          <Stack direction="row" spacing={2} alignItems="center">
            <Typography sx={{ width: 141, fontSize: 13 }}>
              DCP Division Summary{" "}
              <Typography component="span" color="error" sx={{ fontSize: 13 }}>
                *
              </Typography>
            </Typography>
            <Box
              sx={{ display: "flex", alignItems: "center", flex: 1, gap: 1 }}
            >
              <TextField
                fullWidth
                size="small"
                value={dcpDivisionFileName}
                placeholder="Choose file with extension (.csv, .xls, .xlsx)"
                InputProps={{
                  readOnly: true,
                  endAdornment: dcpDivisionFileName && (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => {
                          setDcpDivisionFile(null);
                          setDcpDivisionFileName("");
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={textFieldCommonSx}
              />
              <Button
                component="label"
                sx={{ bgcolor: "#92dede", color: "black", fontSize: 12 }}
              >
                Browse
                <input
                  key={dcpDivisionFileName}
                  hidden
                  accept=".csv,.xls,.xlsx"
                  type="file"
                  onChange={(e) =>
                    handleFileChange(
                      e,
                      setDcpDivisionFile,
                      setDcpDivisionFileName
                    )
                  }
                />
              </Button>
            </Box>
          </Stack>
        </DialogContent>

        {loading && <Loader loading={loading} />}
      </Dialog>

      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        PaperProps={{
          sx: {
            position: "absolute",
            top: 5,
            left: "50%",
            transform: "translateX(-50%)",
            m: 0,
            minWidth: 300,
          },
        }}
      >
        <DialogContent>
          <Typography fontWeight={400} fontSize={14}>
            Would you like to keep the selected accounts for all the future and
            current transactions or only for this transaction?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            size="small"
            sx={{
              textTransform: "none",
              bgcolor: "#6c747d",
              fontWeight: 400,
              fontSize: 12,
            }}
            onClick={() => {
              setDiscountAccount(discountDetailsForDialog);
              setOpenConfirm(false);
              setDiscountDetailsForDialog("");
            }}
          >
            Only for this
          </Button>

          <Button
            variant="contained"
            size="small"
            sx={{
              textTransform: "none",
              bgcolor: "#3e6083",
              fontWeight: 400,
              fontSize: 12,
            }}
            onClick={async () => {
              setOpenConfirm(false);
              const payload = {
                statusCode: 0,
                status: null,
                id: 0,
                corpID: corporation.ID,
                corpName: corporation.Name,
                accountID: discountDetailsForDialog.ID,
                accountName: discountDetailsForDialog.Name,
              };

              try {
                const resp = await updateDiscountAccountAPI(payload, token);
                if (resp.statusCode === 200) {
                  setDiscountAccount(discountDetailsForDialog);
                  setOpenConfirm(false);
                  setDiscountDetailsForDialog("");
                }
                return;
              } catch (err) {
                enqueueSnackbar("Failed to apply discount for all", {
                  variant: "error",
                });
              }
            }}
          >
            Apply for All and Save it
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ImportFilesDialog;
